import Link from "next/link";
import React from "react";
import { twMerge } from "tailwind-merge";
import { SupTabs, SupTab } from "@repo/core-ui";

const tabs = ["about", "vaults", "insights", "activity", "positions"];

export default function ProtocolMenu({ currentTab, slug, className }: { currentTab: string; slug: string; colors: any; className?: string }) {
  return (
    <SupTabs scrollable value={currentTab} className={twMerge("", className)}>
      {tabs.map(tab => (
        <SupTab key={tab} as={Link} value={tab} props={{ href: `/protocol/${slug}/${tab === "about" ? "" : tab}` }} label={tab} />
      ))}
    </SupTabs>
  );
}
